<template>
  <div class="social-schedule-calendar">

		<b-modal size="lg" hide-footer id="editSocialModalCalendar" title="Edit Social Deliverable" class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown" @hide="editSocialModalHidden" @hidden="removeRoute" no-close-on-backdrop no-close-on-esc>
		<EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex" ref="refEditSocialModal" :namespace="namespace"/>
	</b-modal>



		<div class="deliverable-header">
			   <div id="global-spinner-inline" v-if="namespace == ''" v-show="dataLoading" style="left:50%; border:none; background:transparent;z-index:9000;">
				  <b-spinner label="Loading"></b-spinner>
				</div>
				<div class="header-title-tabs-row">
			<HeaderIcon
				:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
				:totalOutletCount="this.outletCount ? this.outletCount : 0"
				:myWeek="false"
				 :namespace="namespace"  v-if="!namespace"
			/>
					<SocialTabs :namespace="namespace" v-if="!namespace"/>
				</div>
			   <div id="global-spinner-above-list" v-if="namespace != ''" v-show="dataLoading" style="left:50%; border:none; background:transparent;z-index:9000;">
				  <b-spinner label="Loading"></b-spinner>
				</div>
		</div>


		<div class="calendar-container" :id="'socialScheduleCalendarContainer'+parentDeliverableId">
			<div class="calendar" ref="SchedulerComponent" :key="'social-calender-ref-'+parentDeliverableId"></div>
		</div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { scheduler } from "../../../../lib/dxhtml-scheduler/sources/dhtmlxscheduler";
import SocialTabs from "../common/SocialTabs";
import EditSocialModal from "./EditSocialModal";
import HeaderIcon from './HeaderIcon';

export default {
	data() {
		return {
			// event IDs are needed for DHTMLX schedule to be able to detach.
			schedulerOnViewChangeId:null,
			schedulerOnSchedulerResizeId:null,
			schedulerOnClickId:null,
			schedulerOnBeforeEventChangedId:null,
			schedulerOnBeforeDragId:null,


			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,

			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,

			undoEnabled: false,
			relatedSocialMediaTabIndex: 0,
			tabIndex: 2,

		}
	},
	props:["namespace", "parentDeliverableId"],
	created() {
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
	},
	components: {
		EditSocialModal,
		SocialTabs,
		HeaderIcon
	},
	computed: {
			...mapState({
		  state (state) {
		    return state[this.namespace]
		  },
		  allContacts (state, getters) {
		    return getters[this.namespace + 'allContacts']
		  },
		  deliverableDetail (state, getters) {
		    return getters[this.namespace + 'deliverableDetail']
		  },
		  deliverableFilter (state, getters) {
		    return getters[this.namespace + 'deliverableFilter']
		  },
		  allCalendarDeliverables (state, getters) {
		    return getters[this.namespace + 'allCalendarDeliverables']
		  },
		  allYearCalendarDeliverables(state, getters) {
		    return getters[this.namespace + 'allYearCalendarDeliverables']
		  },
		  systemSettings (state, getters) {
		    return getters['systemSettings']
		  },
		  allDeliverablesPaginationData (state, getters) {
		    return getters[this.namespace + 'allDeliverablesPaginationData']
		  },
		  outletCount (state, getters) {
		    return getters[this.namespace + 'outletCount']
		  },
		  socialMediaCalendarFilter (state, getters) {
		    return getters[this.namespace + 'socialMediaCalendarFilter']
		  },
		  editDeliverableModal (state, getters) {
		    return getters[this.namespace + 'editDeliverableModal']
		  },
		  addContactModal (state, getters) {
		    return getters[this.namespace + 'addContactModal']
		  },
		  editContactModal (state, getters) {
		    return getters[this.namespace + 'editContactModal']
		  },
		  editSpokespersonModal (state, getters) {
		    return getters[this.namespace + 'editSpokespersonModal']
		  },
		  editWhoModal (state, getters) {
		    return getters[this.namespace + 'editWhoModal']
		  },
		  deliverablePublishStatus (state, getters) {
		    return getters[this.namespace + 'deliverablePublishStatus']
		  },

		  getSocialCampaignNameById (state, getters) {
		    return getters[this.namespace + 'getSocialCampaignNameById']
		  },
		  getSocialSeriesNameById (state, getters) {
		    return getters[this.namespace + 'getSocialSeriesNameById']
		  },
		  getLangNameById (state, getters) {
		    return getters[this.namespace + 'getLangNameById']
		  },
			getSocialNetworkTypeById(state, getters) {
				return getters[this.namespace + 'getSocialNetworkTypeById']
			},
			getSocialNetworkClassById(state, getters) {
				return getters[this.namespace + 'getSocialNetworkClassById']
			},
			getLangCodeById(state, getters) {
				return getters[this.namespace + 'getLangCodeById']
			},
		  dataLoading (state, getters) {
		    return getters[this.namespace + 'dataLoading']
		  },


		}),
 	},
	methods: {
		...mapActions({
		  fetchDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverables', payload)
		  },
		  createTag (dispatch, payload) {
		    return dispatch(this.namespace + 'createTag', payload)
		  },
		  fetchUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUsers', payload)
		  },
		  fetchActiveUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveUsers', payload)
		  },
		  fetchContacts (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchContacts', payload)
		  },
		  updateFieldValue (dispatch, payload) {
		    return dispatch(this.namespace + 'updateFieldValue', payload)
		  },
		  fetchDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDepartments', payload)
		  },
		  fetchActiveDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveDepartments', payload)
		  },
		  fetchSubjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchSubjects', payload)
		  },
		  fetchTags (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchTags', payload)
		  },
		  fetchGeoData (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchGeoData', payload)
		  },
		  fetchAllCustomFields (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchAllCustomFields', payload)
		  },
		  filterDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'filterDeliverables', payload)
		  },
		  fetchViews (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchViews', payload)
		  },
		  fetchProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchProjects', payload)
		  },
		  getDeliverableTypes (dispatch, payload) {
		    return dispatch(this.namespace + 'getDeliverableTypes', payload)
		  },
		  fetchUserManageProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
		  },
		  fetchDeliverableCount (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverableCount', payload)
		  },
		  fetchCalendarDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchCalendarDeliverables', payload)
		  },
		  fetchPartialCalendarDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchPartialCalendarDeliverables', payload)
		  },
		  updateCalendarDeliverablePublishDate (dispatch, payload) {
		    return dispatch(this.namespace + 'updateCalendarDeliverablePublishDate', payload)
		  },
		  undoAction (dispatch, payload) {
		    return dispatch(this.namespace + 'undoAction', payload)
		  },
		  undoUpdateDeliverablePublishDate (dispatch, payload) {
		    return dispatch(this.namespace + 'undoUpdateDeliverablePublishDate', payload)
		  },


		}),
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		  setSocialMediaCalendarFilter (commit, payload) {
		    return commit(this.namespace + 'setSocialMediaCalendarFilter', payload)
		  },
		}),
		mapDeliverableToCalendar() {
			const deliverables = this.allCalendarDeliverables.filter(x => x.publish_date);
			const mappedDeliverables = [];
			deliverables.forEach((x) => {
				let dPublishStatus = {};
				if (typeof x.publish_status == "string") {
					dPublishStatus = JSON.parse(x.publish_status);
				} else {
					dPublishStatus = x.publish_status;
				}
				mappedDeliverables.push({
					id: x.id,
					text: (x.title) ? x.title : x.text,
					preview: (x.preview) ? _.cloneDeep(x.preview):null,
					manually_updated_at: (x.manually_updated_at) ? x.manually_updated_at:null,
					master_deliverable_id: (x.master_deliverable_id) ? x.master_deliverable_id : null,
					start_date: x.publish_date,
					end_date: x.publish_date,
					publish_status: (dPublishStatus) ? dPublishStatus : null,
					published_at: (x.published_at) ? x.published_at : null,
					social_series: (x.social_series) ? _.cloneDeep(x.social_series):null,
					social_campaigns: (x.social_campaigns) ? _.cloneDeep(x.social_campaigns):null,
					color: (dPublishStatus) ?  dPublishStatus.color : "var(--wf-primary)",
					textColor: "var(--wf-secondary)",
				});
			});

			if (Array.isArray(mappedDeliverables) || mappedDeliverables.length > 0) {
			scheduler.parse(mappedDeliverables);
			}
			const { mode, date } = scheduler.getState();
			if (mode == "day") {
				// Scheduler will display the current day scrolled to the first publish time initially
				const scrollToHour = this.findEarliestHour(date);
				scheduler.config.scroll_hour = scrollToHour;
			}

		},

		undoClick() {
			if (this.undoEnabled) {
				this.undoUpdateDeliverablePublishDate().then(() => {
					this.undoEnabled = false;
				});
			}
		},
		viewEntryClick(e) {
			scheduler.clearAll();

			const target = $(e.currentTarget);
			const statusName = target.attr("status-name");
			const statusObject = this.systemSettings.publish_statuses.find(x => x.name == statusName);

			const socialMediaCalendarFilter = this.socialMediaCalendarFilter;

			if (statusName == "All Posts") {
				socialMediaCalendarFilter.publishStatus = [];
			} else {
				socialMediaCalendarFilter.publishStatus = [statusObject];
			}

			this.setSocialMediaCalendarFilter(socialMediaCalendarFilter);

			// this.setDataLoading(true);
			// this.fetchCalendarDeliverables().then(() => {
			// 	// this.mapDeliverableToCalendar();
			// 	this.setDataLoading(false);
			// });

			const viewLabelText = (this.socialMediaCalendarFilter.publishStatus && this.socialMediaCalendarFilter.publishStatus.length == 1) ? this.socialMediaCalendarFilter.publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);

			// this.$root.$emit('calendarSetView');
		},


		editSocialModalShown(){
			document.body.classList.add("social-modal-open");
			// $("#content").scrollTop(this.windowScrollTop);
		},
		afterEditSocialModalShown(){
			document.body.classList.add("social-modal-shown");
			if(this.$router.currentRoute.path.indexOf('social-media/') == -1
			|| this.$router.currentRoute.path.indexOf('social-media-schedule/') == -1
			) {
				history.pushState(
					{},
					null,
					'social-media-schedule/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},


		editSocialModalHidden() {
			document.body.classList.remove("social-modal-open");
			document.body.classList.remove("social-modal-shown");

			if (this.deliverableDetail.is_master) {
				this.setDataLoading(true);
				this.fetchCalendarDeliverables({filter:this.socialMediaCalendarFilter}).then(() => {
					// this.mapDeliverableToCalendar();
					this.setDataLoading(false);
				});
			} else {
				this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
			}
				this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
		},




		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') == -1) {
				history.pushState(
					{},
					null,
					'social-media/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			this.setDataLoading(true);
			this.fetchCalendarDeliverables({filter:this.socialMediaCalendarFilter}).then(() => {
				this.mapDeliverableToCalendar();
				schedule.setCurrentView();
				this.setDataLoading(false);
			});

			if(this.$router.currentRoute.path.indexOf('social-media/') != -1) {
				this.$router.push({name: 'socialMedia'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				$router.push(this.$router.currentRoute.path).catch(err => {console.error(err)});
			}



		},

  pushRoute() {
    	return;
    	if (this.isListView) {
    		history.pushState(
    			{},
    			null,
    			'/social-media/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
    		)
    	} else {
    		history.pushState(
    			{},
    			null,
    			'/social-media-grouped/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
    		)
    	}
    	let currentTitle = document.title.match(/\(\d+\)\s/g);
    	if (!currentTitle) {
    		document.title = this.deliverableDetail.title;
    	} else {
    		document.title = currentTitle[0] + this.deliverableDetail.title;
    	}
    },

    removeRoute() {
    	history.pushState(
    		{},
    		null,
    		this.$router.currentRoute.matched[0].path
    	);
    },


    showEditDeliverableModal(deliverable, tab) {

      this.windowScrollTop = $(window).scrollTop();
      let deliverableId = null;

      if (typeof deliverable === "object") {
        deliverableId = deliverable.id;
        this.selectedDeliverable = deliverable.id;
        if (deliverable.social_series.length && !deliverable.manually_updated_at) {
          deliverableId = this.getSeriesMasterByDeliverable(deliverable);
        }
      } else {
        deliverableId = deliverable;
        this.selectedDeliverable = deliverableId;
      }
      if (tab === null || tab === undefined) {
        tab = 2;
      }

      this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
        .then(() => {
          this.pushRoute();
          this.$bvModal.show("editRelatedSocialModal", {
            backdrop: 'static',
            keyboard: true,
          });
          this.tabIndex = tab;
        });
      this.$root.$emit('bv::modal::disable-pointer-events');
    },



		showModalFn(deliverableId) {

			// shows edit deliverable modal
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}

					this.$bvModal.show('editRelatedSocialModal');
					this.tabIndex = 2;

					/*
					if (this.namespace == "relatedDeliverables/") {
						this.$bvModal.show('editRelatedSocialModal');
						this.tabIndex = 2;
					} else {
						this.$bvModal.show('editSocialModal');
						this.tabIndex = 2;
					}
					*/
				});
		},

		onSocialMediaDeliverableTitleUpdated(deliverableDetail) {
			const targetEvent = this.allCalendarDeliverables.find(x => x.id == deliverableDetail.id);
			if (targetEvent) {
				targetEvent.title = deliverableDetail.title;
				this.mapDeliverableToCalendar();
			}
		},
		async changeEventPublishDate(ev) {
			const requestData = {
				id: ev.id,
				value: this.$moment(ev.start_date).toISOString(),
				return: "calendar"
			}

			return this.updateCalendarDeliverablePublishDate(requestData)
				.then(() => {
					this.undoEnabled = true;
					return true;
				})
				.catch(error => {
					return false;
				});
		},

		onCalendarViewChange(min_date, max_date) {
			/*
			// TODO: temporarily disabled view dropdown
			document.querySelector(".social-media-view-button").setAttribute("data-toggle", "dropdown");
			$(".social-schedule-calendar .viewmenu-dropdown a.dropdown-item").on("click", (e) => this.viewEntryClick(e));

			const viewLabelText = (this.socialMediaCalendarFilter.publishStatus && this.socialMediaCalendarFilter.publishStatus.length == 1) ? this.socialMediaCalendarFilter.publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);
			*/

			this.socialMediaCalendarFilter.listByPublishDate = true;
			this.socialMediaCalendarFilter.listByDate = false;
			this.socialMediaCalendarFilter.parentDeliverableId = this.parentDeliverableId;
			if (!this.socialMediaCalendarFilter.listDatePublishRange) this.socialMediaCalendarFilter.listDatePublishRange = {};
			this.socialMediaCalendarFilter.listDatePublishRange.startDate = min_date;
			this.socialMediaCalendarFilter.listDatePublishRange.endDate = max_date;

			this.setSocialMediaCalendarFilter(this.socialMediaCalendarFilter);
			this.setDataLoading(true);
			this.fetchCalendarDeliverables({filter:this.socialMediaCalendarFilter}).then(() => {
				// this.mapDeliverableToCalendar();
				this.setDataLoading(false);
			});

			this.$nextTick(() => {
			this.setUndoButtonEnabled();
			});



		},

		setUndoButtonEnabled(v) {
			if (v === undefined) {
				v = this.undoEnabled;
			}

			if (v) {
			this.$nextTick(() => {
					$(".social-schedule-calendar .social-media-undo-button").removeClass("disabled");
				});
			} else {
			this.$nextTick(() => {
				setTimeout(function() {
				$(".social-media-undo-button").addClass("disabled");
				}, 1000);
			});
			}
		},

		checkIfEventDraggable(id) {
			const targetEvent = this.allCalendarDeliverables.find(x => x.id == id);
			if (!targetEvent) return false;

			const publishStatus = targetEvent.publish_status;

			// Hardcode
			if (
				publishStatus.slug == 'published' ||
				targetEvent.published_at
			) {
				// toast.error("Cannot change the publish date because the deliverable has already been published.")
				return false;
			}
			return true;
		},

		checkIfPublishStatusFilterChange(publishStatus) {
			const viewLabelText = (publishStatus && publishStatus.length == 1) ? publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);
		},

		async schedulerOnViewChange(new_mode, new_date) {
			await this.dynamicLoading();
			const mode = new_mode;
			localStorage.setItem('socialMediaCalendarView', mode);
			if (mode == "day") {
				scheduler.xy.min_event_height = 176;
				// hour_size_px, the height of an hour unit in pixels 	default = 42
				// 440 gives 10 equal divisions, 220 gives 5 equal divisions
				scheduler.config.hour_size_px = 176;

				let format = scheduler.date.date_to_str("%H:%i");
				let step = 10;
				scheduler.templates.hour_scale = function (date) {
					let html = "";
					for (let i = 0; i < (60 / step); i++) {
						if (i == 0) {
							html += format(date) ;
						}
						date = scheduler.date.add(date, step, "minute");
					}
					return html;
				}
				scheduler.templates.event_class = function (start, end, event) {
					return `day-mode-preview item-1`;
				};
				scheduler.templates.event_header = function (start, end, event) {
					let html = '';
					html += '<div class="day-flex">';
					html += '<div class="dhx_event-tooltip-time">' + scheduler.templates.event_date(start) + '</div>';
					html += '<div class="dhx_event-tooltip-title">' + event.text + '</div>';
					html += '<div class="dhx_event-tooltip-status" style="color:' + event.publish_status?.color + '">' +
						event.publish_status?.name + '</div>';
					html += "</div>";
					return html;
				};
				let that = this;
				scheduler.templates.event_text = function (start, end, event) {
					let html = '';
					if (typeof event.preview != "undefined" && event.preview != null) {
						html += '<div class="dhx_event-tooltip-preview-wrapper">';
						html += '<div class="top-info-bubbles">';
						for (let i = 0; i < event.preview.length; i++) {
							html += '<div class="top-info-bubbles-set">';
							if (typeof event.preview[i].lang_id != "undefined") {
								html += '<span class="info-bubbles languages"><span title="' +
									that.getLangCodeById(event.preview[i].lang_id) +
									'" class="languages initials badge">' +
									that.getLangCodeById(event.preview[i].lang_id) +
									'</span></span>';
							}
							if (typeof event.preview[i].social_networks != "undefined") {
								event.preview[i].social_networks.forEach(snId => {
									html += '<span class="info-bubbles social-networks"><span title="' +
										that.getSocialNetworkTypeById(snId) +
										'" class="social-networks initials badge">' +
										'<i class="fab fa-' + that.getSocialNetworkClassById(snId) + ' platform-indicator"></i>' +
										'</span></span>';
								});
							}
							html += "</div>";
						}
						html += "</div>";
						for (let i = 0; i < event.preview.length; i++) {
							if (i == 0) {
								html += '<div class="dhx_event-tooltip-preview">';
								let placeholderFilename = process.env.MIX_APP_URL + "images/sm-calendar-placeholder.svg";
								if (typeof event.preview[i].files[0] != "undefined") {
									if (event.preview[i].files[0].file_name) {
										let filename = process.env.MIX_API_BASE_URL +
											"viewFileSocialMediaPostResized/thumbnail/" +
											event.preview[i].files[0].social_post_id + "/" +
											event.preview[i].files[0].id + "/" +
											that.$store.getters.authToken + "/"
											event.preview[i].files[0].thumbnail_filename;
										html += `<div class="dhx_event-tooltip-image box">
											<img src="${filename}" 
												alt="${event.preview[i].files[0].alt_text}"
												onerror="this.onerror=null; this.src='${placeholderFilename}'"
											/>
										</div>`;
									} else {
										html += '<div class="dhx_event-tooltip-image box"><img src="' + placeholderFilename + '"/></div>';
									}
								} else {
									html += '<div class="dhx_event-tooltip-image box"><img src="' + placeholderFilename + '"/></div>';
								}
								html += '<div class="box-info-bubbles">';
								if (event.preview[i].caption == null) {
									html += '<span class="dhx_event-tooltip-body">No post copy</span>';
								} else {
									let caption = event.preview[i].caption;
									html += '<span class="dhx_event-tooltip-body">' +
										caption +
										'</span>';
								}
								html += "</div>";
							}
						}
						html += "</div>";
					} else {
						html = event.text;
					}
					return html;
				}
			} else if (mode == "week") {
				scheduler.xy.min_event_height = 40;
				scheduler.config.hour_size_px = 44;
				scheduler.config.scroll_hour = new Date().getHours();

				let format = scheduler.date.date_to_str("%H:%i");
				let step = 60;
				scheduler.templates.hour_scale = function (date) {
					let html = "";
					for (let i = 0; i < 60 / step; i++) {
						if (i == 0) {
							html +=  format(date);
						}
						date = scheduler.date.add(date, step, "minute");
					}
					return html;
				}
				scheduler.templates.event_class = function (start, end, event) {
					return "";
				};
				scheduler.templates.event_header = function (start, end, ev) {
					return scheduler.templates.event_date(start);
				};
				scheduler.templates.event_text = function (start, end, event) {
					return event.text;
				};
			} else {
				// reset to default values
				scheduler.xy.min_event_height = 40;
				scheduler.config.hour_size_px = 42;
				scheduler.config.scroll_hour = new Date().getHours();
				let format = scheduler.date.date_to_str("%H:%i");
				let step = 60;
				scheduler.templates.hour_scale = function (date) {
					let html = "";
					for (let i = 0; i < 60 / step; i++) {
						html += "<div style='height:22px;line-height:22px;'>" + format(date) + "</div>";
						date = scheduler.date.add(date, step, "minute");
					}
					return html;
				}
				scheduler.templates.event_class = function (start, end, event) {
					return "";
				};
				scheduler.templates.event_header = function (start, end, ev) {
					return scheduler.templates.event_date(start) + " - " +
						scheduler.templates.event_date(end);
				};
				scheduler.templates.event_text = function (start, end, event) {
					return event.text;
				};
			}
			// const {min_date, max_date} = scheduler.getState();
			// this.onCalendarViewChange(min_date, max_date);
			// this.forceResizeCalender();

		},

		schedulerOnSchedulerResize (){
			// this.forceResizeCalender();

		},

		schedulerOnClick(id, e) {
			const { mode } = scheduler.getState();
			var event = scheduler.getEvent(id);
			if (mode == "year") {
				// on click on "year" tooltip reload to that day view
				var postPublishDate = new Date(event.start_date);
				var newFormattedDate = new Date(
					postPublishDate.getFullYear(),
					postPublishDate.getMonth(),
					postPublishDate.getDate()
				);
				scheduler.setCurrentView(newFormattedDate, "day");
			} else {
				// "day", "week", "agenda", "month"
				// open editModal for corresponding deliverable
				if (event.master_deliverable_id && event.manually_updated_at == null) {
					this.$emit("showEditDeliverableModal", event.master_deliverable_id);
				} else {
					this.$emit("showEditDeliverableModal", id);
				}
			}

	/*
			 var event = scheduler.getEvent(id);
			if (event.master_deliverable_id && event.manually_updated_at == null) {
				this.showModalFn(event.master_deliverable_id);
			} else {
				this.showModalFn(id);
			}
	*/

		},

		forceResizeCalender() {
			let that = this;
			this.$nextTick(() => {
				let calendarContainer =  $("#socialScheduleCalendarContainer"+this.parentDeliverableId+" .dhx_cal_container");
				if (calendarContainer ) {
					if (calendarContainer[0]) {
						if (calendarContainer[0].clientHeight < 150) {
								scheduler.setCurrentView();
								that.setUndoButtonEnabled();
								setTimeout(that.forceResizeCalender, 250 ,scheduler);
						}
					} else {
						setTimeout(that.forceResizeCalender, 250 ,scheduler);
					}
				}
			});
		},

		schedulerOnBeforeEventChanged(ev, e, is_new, original){
			// don't let them manually add new entries to the calendar by double-clicking.
			if (is_new) {
					return false;
			}

			return this.changeEventPublishDate(ev);

		},

		schedulerOnBeforeDrag(id) {
			var canDrag = this.checkIfEventDraggable(id);
			return canDrag;
		},

		findEarliestHour(currentDate) {
			const today = this.$moment(currentDate).startOf('day');
			const deliverablesWithPublishDate = this.allCalendarDeliverables.filter(x => x.publish_date);
			if (
				Array.isArray(deliverablesWithPublishDate) &&
				deliverablesWithPublishDate.length > 0
			) {
				const deliverablesWithTodayDate = deliverablesWithPublishDate.filter(deliverable => {
					const publishDate = this.$moment.utc(deliverable.publish_date).local().format();
					const isToday = today.isSame(publishDate, 'day');
					return isToday;
				});
				let earliestPublishDate = null;
				deliverablesWithTodayDate.forEach(deliverable => {
					const publishDate = this.$moment.utc(deliverable.publish_date);
					if (!earliestPublishDate || publishDate.isBefore(earliestPublishDate)) {
						earliestPublishDate = publishDate;
					}
				});
				if (earliestPublishDate) {
					const localHours = earliestPublishDate.local().hour();
					return localHours;
				}
			}
			return 0; // default: midnight
		},
		navigateToDate(targetDate, viewMode = 'month') {
			if (!targetDate || !viewMode) {
				return;
			}
			const date = targetDate instanceof Date ? targetDate : new Date(targetDate);
			const that = this;
			this.$nextTick(() => {
				if (typeof scheduler !== 'undefined' && scheduler.setCurrentView) {
					scheduler.setCurrentView(date, viewMode);
					if (viewMode === 'day') {
						that.scrollToHour(date.getHours());
					}
				}
			});
		},
		scrollToHour(targetHour) {
			const that = this;
			setTimeout(() => {
				const hourHeight = scheduler.config.hour_size_px;
				const scrollTop = Math.max(0, targetHour - 1) * hourHeight;
				const selectors = [
					'#socialScheduleCalendarContainer' + that.parentDeliverableId + ' .dhx_cal_data',
					'.dhx_cal_data',
					'.dhx_cal_container .dhx_cal_data'
				];
				for (const selector of selectors) {
					const container = document.querySelector(selector);
					if (container) {
						container.scrollTop = scrollTop;
						break;
					}
				}
			}, 800);
		},
		mapYearDeliverableToCalendar() {
			let yearEvents = [];
			if (
				Array.isArray(this.allYearCalendarDeliverables) &&
				this.allYearCalendarDeliverables.length > 0
			) {
				yearEvents = this.allYearCalendarDeliverables.filter(x => x.publish_date);
			}
			// removes all events from the scheduler
			scheduler.clearAll();
			// year has different format so parse here
			// update with empty array also
			scheduler.parse(yearEvents);
		},

		async dynamicLoading() {
			try {
				const { mode, min_date, max_date } = scheduler.getState();
				let filterQuery = { ...this.socialMediaCalendarFilter, mode, min_date, max_date };
				this.$root.$emit(this.namespace + 'setPartialCalendarFilter', filterQuery);
			} catch (error) {
				console.error("Error: ", error);
			}
		},

	},
	mounted() {
		let that = this;

		let viewDropdownItem = '';
				viewDropdownItem += `<a class="dropdown-item" style="background-color: 'var(--hover-grey)'" status-name="All Posts">All Posts</a>`;

		this.systemSettings.publish_statuses.forEach(x => {
			viewDropdownItem += `<a class="dropdown-item" style="background-color: ${x.color}" status-name="${x.name}">${x.name}</a>`;
		});


		// var evId, evStart, evEnd;
		// schedulerOnBeforeDrag", function (id, mode, e){
		//   if(mode != "create"){
		//     evId = id;
		//     evStart = scheduler.getEvent(id).start_date
		//     evEnd = scheduler.getEvent(id).end_date
		//   }
		//   return true;
		// });

		// scheduler.addShortcut("c", function(e){
		//   var ev = scheduler.getEvent(evId)
		//   ev.start_date = evStart
		//   ev.end_date = evEnd
		//   scheduler.updateEvent(ev.id);
		// },"ev");

		scheduler.skin = "material";

		scheduler.config.header = [
			"day",
			"week",
			"week_agenda",
			"month",
			"year",
			"prev",
			"date",
			"next",
			"today",
			// {html:
			// 	`<span class="mr-3 view__label truncate-text">Views</span>
			// 	 <img class="view__icon" src="/images/dropdown-arrow.svg" alt="" />
			// 	<div class="dropdown-menu viewmenu-dropdown">
			// 		<div>
			// 			${viewDropdownItem}
			// 		</div>
			// 	</div>`
			//	, css: "social-media-view-button"},
			// {html:'<span id="undoCalendar"  class="mr-3 undo__label truncate-text "><img class="undo-icon" src="/images/undo.svg" alt="" /><span class="undo-text">Undo</span></span>', click:that.undoClick, css: "social-media-undo-button"},
		];
		scheduler.plugins({
			container_autoresize: true,
			year_view: true
			,week_agenda: true
			,tooltip: false
		});

		scheduler.config.drag_resize = false;
		scheduler.config.dblclick_create = false;
		scheduler.config.server_utc = true;
		scheduler.config.drag_move = true;
		scheduler.config.timeout_to_display = 500;
		scheduler.config.separate_short_events = true;
		scheduler.config.preserve_scroll = false;
		scheduler.config.scroll_hour = new Date().getHours();
				const savedViewMode = localStorage.getItem('socialMediaCalendarView');
				const defaultViewMode = this.namespace == "relatedDeliverables/" ? "month" : "week";
				const initialViewMode = savedViewMode || defaultViewMode;

				scheduler.init(
					this.$refs.SchedulerComponent,
					new Date(),
					initialViewMode
				);
				this.dynamicLoading();

		this.schedulerOnViewChangeId = scheduler.attachEvent("onViewChange", this.schedulerOnViewChange);
		this.schedulerOnSchedulerResizeId = scheduler.attachEvent("onSchedulerResize", this.schedulerOnSchedulerResize);
		this.schedulerOnClickId = scheduler.attachEvent("onClick", this.schedulerOnClick);
		this.schedulerOnBeforeEventChangedId = scheduler.attachEvent("onBeforeEventChanged", this.schedulerOnBeforeEventChanged);
		this.schedulerOnBeforeDragId = scheduler.attachEvent("onBeforeDrag", this.schedulerOnBeforeDrag);


		this.schedulerOnSchedulerResize();

		// Click event for view
		$(".social-schedule-calendar .viewmenu-dropdown a.dropdown-item").on("click", (e) => that.viewEntryClick(e));

		this.$root.$on('socialMediaDeliverableTitleUpdated', this.onSocialMediaDeliverableTitleUpdated);

		document.body.classList.add("social-modal-calendar-open");

	},
	beforeDestroy() {
		scheduler.detachEvent(this.schedulerOnViewChangeId);
		scheduler.detachEvent(this.schedulerOnSchedulerResizeId);
		scheduler.detachEvent(this.schedulerOnClickId);
		scheduler.detachEvent(this.schedulerOnBeforeEventChangedId);
		scheduler.detachEvent(this.schedulerOnBeforeDragId);
		document.body.classList.remove("social-modal-calendar-open");
	},
	watch: {
		allCalendarDeliverables: {
			handler: function () {
				scheduler.clearAll();
				this.mapDeliverableToCalendar();
			},
			deep: true,
			immediate: true 
		},
		allYearCalendarDeliverables: {
			handler: function () {
				this.mapYearDeliverableToCalendar();
			},
			deep: true,
			immediate: true 
		},
		undoEnabled: {
			handler: function (v) {
				this.setUndoButtonEnabled(v);
			}
		},
		socialMediaCalendarFilter: {
			handler: function (v) {
				this.checkIfPublishStatusFilterChange(v.publishStatus);
			},
			deep: true,
			immediate: true 
		},
		parentDeliverableId: {
			handler: function (v) {
			this.fetchCalendarDeliverables();
			}
		}

	}
};
</script>
